import { render } from "./CreateNewArticleNumber.vue?vue&type=template&id=b34f1612"
import script from "./CreateNewArticleNumber.vue?vue&type=script&lang=js"
export * from "./CreateNewArticleNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__